import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import SongTrackLoader from '../../components/loader/songTrackLoader';
import MonthlyTopSongs from '../../components/monthlyTopSongs/monthlyTopSongs';
import RightSide from "../../components/rightSide/rightSide";
import SongTrack from '../../components/songTrack/songTrack';
import Pagination from "react-js-pagination";
import Spinner from 'react-bootstrap/Spinner';
import MusicDashboard from '../../layouts/musicDashboard';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { connect } from 'react-redux';

import * as songActions from '../../store/song/actions';


const  RecommendedSongs = ({ loggingIn, genres,  getRecommendedSongs, newRelease, paginationData, displayLoading, hideLoading }) => {

    const navigate = useNavigate();
    const scrollRef = useRef(null);
    const [ page, setPage ] = useState(1);
    const [ order, setOrder ] = useState('entity_id');
    const [ orderDir, setOrderDir ] = useState('DESC');
    const [ songSectionId, setSongSectionId ] = useState(1);
    const [ currentGenreId, setCurrentGenreId ] = useState();
    const [ processing, setProcessing ] = useState(false);
    const [ selectedGenres, setSelectedGenres ] = useState([]);
	
  	useEffect(() => { 
		if(loggingIn !== undefined && loggingIn === false){
			navigate('/sign-in');
		} else {
			loadData()
		}
	   },[])
	   
	const loadData = async() =>{
        // Get genres filter to display on homepage
        displayLoading();
        setProcessing(true);
		await getRecommendedSongs({page: page, order: order, limit: 20, orderDir, song_section_id: songSectionId});
        hideLoading();
        setProcessing(false);
        window.scrollTo({top: 0});
    } 
    
    const handlePageChange = (pageNumber) => {
        displayLoading();
        setProcessing(true);
        setPage(pageNumber);
        getRecommendedSongs({page: pageNumber, order: order, limit: 20, orderDir, song_section_id: songSectionId}).then((res) => {
            hideLoading();
            setProcessing(false);
        })
        scrollRef.current?.scrollIntoView({behavior: 'smooth'});
          
    }

	return (
			<MusicDashboard rightContent={<RightSide blocks={{ top30TrendingTracks: true}} />}>
                <div className="content-sec">
                    <MonthlyTopSongs />
                    <div className="play-list-sec">
                        <div className="top-heading">
                            <h2>Recommended for you</h2>
                        </div>
                        <div className="inner-block">
                            <div ref={scrollRef}>  {    processing ? <SongTrackLoader itemCount={20} /> : <SongTrack songs={newRelease}  />  }</div> 
                        </div>
                    </div>
                    
                    <div className="pagingnation-sec">
                        {
                        paginationData ? 
                            <Pagination
                                activePage={paginationData.page}
                                itemsCountPerPage={paginationData.perPageLimit}
                                totalItemsCount={parseInt(paginationData.totalCount)}
                                // pageRangeDisplayed={pageRangeDisplayed}
                                onChange={handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                        /> : ''
                        }
                    </div>
                </div>
        </MusicDashboard>
    );
}

function mapStateToProps(state) {
    // console.log('songs', state.song.recommendedSongs)
	return {
        loggingIn: state.authentication.loggedIn,
        newRelease: (state.song.recommendedSongs && state.song.recommendedSongs.songs ) ? state.song.recommendedSongs.songs : [],
        paginationData:  (state.song.recommendedSongs && state.song.recommendedSongs.pagination) ? state.song.recommendedSongs.pagination : '',
        genres: state.genre.genresWithCount,
        top20Albums: state.song.top20Albums,
	};
 }
 
function mapDispatchToProps(dispatch) {
	return {
		getRecommendedSongs: (post) => dispatch(songActions.getRecommendedSongs(post)),
        displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
    	hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
	};
 }

export default connect(mapStateToProps, mapDispatchToProps)(RecommendedSongs);
